module.exports = __webpack_public_path__ + "static/media/zapsplat_cartoon_dog_confused_huh_vocalisation_002_32269.ab3e5bad.mp3";